import { render, staticRenderFns } from "./CommonMiniUpload.vue?vue&type=template&id=2354875e&scoped=true"
import script from "./CommonMiniUpload.vue?vue&type=script&lang=js"
export * from "./CommonMiniUpload.vue?vue&type=script&lang=js"
import style0 from "./CommonMiniUpload.vue?vue&type=style&index=0&id=2354875e&prod&lang=css"
import style1 from "./CommonMiniUpload.vue?vue&type=style&index=1&id=2354875e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354875e",
  null
  
)

export default component.exports